import UMS from "../classes/UMS";

window.UMS = new UMS;